namespace GeniuzPOS.QRreport {
    export interface QRyReportCustomerSurveyForm {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DateBegin: Serenity.DateEditor;
        DateEnd: Serenity.DateEditor;
        ShopId: Serenity.LookupEditor;
        PosId: Serenity.LookupEditor;
        CashierId: Serenity.LookupEditor;
        MbId: Serenity.LookupEditor;
        Qty_AmtFg: Serenity.IntegerEditor;
    }

    export class QRyReportCustomerSurveyForm extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRyReportCustomerSurvey';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRyReportCustomerSurveyForm.init)  {
                QRyReportCustomerSurveyForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateEditor;

                Q.initFormType(QRyReportCustomerSurveyForm, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DateBegin', w3,
                    'DateEnd', w3,
                    'ShopId', w0,
                    'PosId', w0,
                    'CashierId', w0,
                    'MbId', w0,
                    'Qty_AmtFg', w2
                ]);
            }
        }
    }
}
